import PropTypes from 'prop-types';
import React from 'react';

import { toJS } from 'mobx';
import { Row, Col, Label, FormGroup, Separator, SimpleAlert } from 'twyne-new.ui';

import Switch from '@Components/form/Switch';
import Rules from '@Components/rules/Rules';

export default class PathPagesRulesForm extends React.Component {
  state = {
    conflictEvent: null,
  }

  handleConflict = (event) => {
    this.setState({ conflictEvent: event })
  }

  loadData = ({ pageData }) => {
    this.setState(prevState => {
      const state = {
        overridden: false,
        enableSave: false,
      }
      if (pageData) {
        if (pageData.path_pages && pageData.path_pages.rules) {
          state.overridden = true
          state.rules = pageData.path_pages.rules
          return state
        }
        if (pageData.rules) {
          state.rules = toJS(pageData.rules)
          return state
        }
      }
      state.rules = {
        condition: 'and',
        groups: [],
      }
      return state
    });
  }

  componentWillMount() {
    this.loadData(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.pageData !== this.props.pageData) {
      this.loadData(nextProps)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.enableSave !== this.state.enableSave || prevState.conflictEvent !== this.state.conflictEvent) {
      this.props.onStatusChange?.({ enableSave: this.state.enableSave, conflictEvent: this.state.conflictEvent })
    }
  }

  handleChange = state => {
    state.enableSave = true
    this.setState(state)
  }

  handleOpenValidatorModal = id => {
    const { path_pages } = this.props.pageData

    path_pages.rules = this.state.rules

    if (!this.state.overridden) {
      path_pages.rules = null
    }

    this.props.onOpenValidatorModal(path_pages, id)
  }

  Form = () => <Row className='mt-4'>
    <Col size="12">
      <Separator className='mx-0' />
    </Col>
    <Col size="12">
      <FormGroup>
        <div className='flex justify-between'>
          <span className='text-md twy-text-base-accent'>Rules</span>
          <div className='flex items-center gap-2'>
            <Switch
              name="override"
              setValue={overridden => this.handleChange({ overridden })}
              value={this.state.overridden}
            />
            <Label>{this.props.pageData.rules ? "Override default page rules" : "Active"}</Label>
          </div>
        </div>
      </FormGroup>
    </Col>
    {this.state.overridden && <>
      <Col size="12">
        <Rules rules={this.state.rules}
          disabled={!this.state.overridden}
          handleChange={state => this.handleChange(state)}
          origin='path-page'
          handleOpenValidatorModal={this.handleOpenValidatorModal}
          onConflict={this.handleConflict}
        />
      </Col>
    </>}
  </Row>

  render() {
    if (this.props.pageData.path_pages) {
      return <this.Form />
    } else {
      return <>
        <SimpleAlert>
          Save the path form before edit the rules for this page
        </SimpleAlert>
      </>
    }
  }
}

PathPagesRulesForm.propTypes = {
  onStatusChange: PropTypes.func,
  pageData: PropTypes.any,
};
